import { InvitingUserComponent } from './../../../shared/common/inviting-user/inviting-user.component';
import { InvitedUserComponent } from './../authentication/invited-user/invited-user.component';
import { Component, OnInit } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})

export class OnboardingComponent implements OnInit {
  firstName: any;
  lastName: any;
  empRole: any;
  profileId: any;
  tenantId: '';
  invitedUsersList: any = [];
  invitedUsers: number;
  onBoardUsers: number;
  onWaitList: number;
  projectId: string;
  projectMembers: any = [];
  projectCount = 0;
  projectMemberImages: any = [];
  resourceCount = 0;
  reportingTo: string;
  filteredOptions: Observable<string[]>;
  cols = [
    { field: 'position', header: 'S.No' },
    { field: 'FirstName', header: 'First Name' },
    { field: 'LastName', header: 'Last Name' },
    { field: 'officialEmail', header: 'Email' },
    { field: 'status', header: 'Status' },
    { field: 'projectName', header: 'Project Name' },
    { field: 'action', header: 'Action' }
  ];

  projectcols = [
    { field: 'position', header: 'S.No' },
    { field: 'projectsName', header: 'Project Name' },
    // { field: 'task', header: 'Task' },
    { field: 'members', header: 'Members' }
  ];

  constructor(
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private dataService: DataService,
    private configuration: Configuration,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.firstName = this.parseService.instance.User.current().get('firstName');
    this.lastName = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getInvitedUser();
    this.getOnBoarded();
    this.getWaitList();
    // this.assignedProjectMembers();
    this.getProject();
  }

  async getInvitedUser() {
    this.invitedUsersList = [];
    const queryInstance = this.parseService.instance.Object.extend('InvitedUser');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('projectId');
    query.equalTo('tenantId', this.tenantId);
    query.descending("createdAt");
    let res = await query.find();
    this.invitedUsers = res.length;
    let i = 0;
    for (let inviteUser of res) {
      i = i + 1;
      let firstName = inviteUser.attributes.firstName;
      let lastName = inviteUser.attributes.lastName;
      let email = inviteUser.attributes.email;
      let status = inviteUser.attributes.status === 'OnBoarding' ? 'OnBoarded' : inviteUser.attributes.status;
      let projectName = inviteUser.attributes.projectId.attributes.projectInfo.projectName;
      this.projectId = inviteUser.attributes.projectId.id;
      this.reportingTo = inviteUser.attributes.reportingTo;
      this.invitedUsersList.push({
        position: i,
        FirstName: firstName,
        LastName: lastName,
        officialEmail: email,
        status: status,
        projectName: projectName
      });
    }
    this.resourceCount = this.invitedUsersList.length;
  }

  async getOnBoarded() {
    const queryInstance = this.parseService.instance.Object.extend('InvitedUser');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('status', "OnBoarding");
    let res = await query.find();
    this.onBoardUsers = res.length;
  }

  async getWaitList() {
    const queryInstance = this.parseService.instance.Object.extend('InvitedUser');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('status', 'Waiting');
    let res = await query.find();
    this.onWaitList = res.length;
  }

  async getProject(): Promise<void> {
    const projectList = [];
    let index = 1;
    const Project = this.parseService.instance.Object.extend('Project');
    const projectQuery = new this.parseService.instance.Query(Project);
    projectQuery.equalTo('tenantId', this.tenantId);
    projectQuery.equalTo('defaultProject', false);
    projectQuery.descending("createdAt");
    const projectResult = await projectQuery.find();

    //  projectResult.forEach(async (project) => {
    for (let project of projectResult) {
      const taskCount = await this.getProjectTask(project.id);
      await this.getProjectMember(project).then((projectMember) => {
        const obj = {
          position: index,
          projectsName: project.attributes.projectInfo.projectName,
          members: projectMember,
          // task: taskCount.length
        };
        index += 1;
        projectList.push(obj);
      });
    }
    // });
    this.projectMembers = projectList;
    this.projectCount = this.projectMembers.length;
    // });
  }

  async getProjectMember(project): Promise<any> {
    const projectMemberProfiles = [];
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    // projectMembers.equalTo('isInvited', true);
    projectMembers.equalTo('tenantId', this.tenantId);
    projectMembers.include('user');
    projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: project.id });
    const projectMembersData = await projectMembers.find();
    projectMembersData.forEach((projectMember) => {
      const obj = {
        id: projectMember.attributes.user.attributes.profile.attributes.id,
        image: projectMember.attributes.user.attributes.profile.attributes.profileImageInfo.url,
        name: projectMember.attributes.user.attributes.profile.attributes.username
      };
      projectMemberProfiles.push(obj);
    });
    return await projectMemberProfiles;
  }

  async getProjectTask(projectId) {
    const Task = this.parseService.instance.Object.extend('Tasks');
    const task = new this.parseService.instance.Query(Task);
    task.equalTo('Project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    const taskData = await task.find();
    return taskData;
  }

  async assignedProjectMembers() {
    const queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isInvited', true);
    query.equalTo('tenantId', this.tenantId);
    query.include('user');
    let res = await query.find();

    for (let data of res) {
      let projectMemberId = data.attributes.user.attributes.profile.attributes.id;
      let projectMemberName = data.attributes.user.attributes.profile.attributes.username;
      let projectMembersImg = data.attributes.user.attributes.profile.attributes.profileImageInfo.url;
      this.projectMemberImages.push({
        id: projectMemberId,
        image: projectMembersImg,
        name: projectMemberName
      });
    }
    let projectName = res[0].attributes.project.attributes.projectInfo.projectName;
    this.projectMembers.push({
      position: 1,
      projectsName: projectName,
      members: this.projectMemberImages
    })
    this.projectCount = this.projectMembers.length;
  }

  sendInviteMemberEmail(email) {
    this.spinner.show();
    this.dataService.add(this.configuration.reSendInviteEmail + '?tenantId=' + this.tenantId + '&reportingId=' + this.reportingTo + '&projectId=' + this.projectId, [email]).subscribe((data: any) => {
      this.toastr.success('Email Send successfully');
      this.spinner.hide();
    }, error => {
      this.toastr.warning('Unable to Send Email');
      console.log('error', error);
      this.spinner.hide();
    });
  }

  openInviteUserDialog(): void {
    const dialogRef = this.dialog.open(InvitingUserComponent, {
      width: '500px',
      data: { isEdit: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.getHolidayList();
      this.getInvitedUser();
      this.getWaitList();
    });
  }

  projectCreate() {
    this.router.navigate(['/project-create', { onboard: 'true' }]);
  }

}


